import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { authAPI } from '../utils/api';
import { useAuth } from '../context/AuthContext';
import './Auth.css';

const VerifyEmail = () => {
  const [code, setCode] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const email = location.state?.email;

  const handleVerify = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const res = await authAPI.verifyEmail({ email, code });
      login(res.data, res.data.token);
      if (res.data.role === 'provider') navigate('/provider');
      else navigate('/dashboard');
    } catch (err) {
      setError(err.response?.data?.message || 'Invalid code. Try again.');
    }
    setLoading(false);
  };

  return (
    <div className="auth-page">
      <div className="auth-left">
        <div className="auth-brand">
          <div className="auth-logo">SS</div>
          <h2>SmartService</h2>
        </div>
        <h1>Check Your Email!</h1>
        <p>We sent a 6-digit verification code to your email address. Enter it below to activate your account.</p>
        <div className="auth-features">
          <div className="auth-feature">📧 Check your inbox</div>
          <div className="auth-feature">🔢 Enter 6-digit code</div>
          <div className="auth-feature">⏱️ Code expires in 10 minutes</div>
        </div>
      </div>

      <div className="auth-right">
        <div className="auth-form-box">
          <h2>Verify Your Email</h2>
          <p className="auth-sub">Code sent to: <strong>{email}</strong></p>

          {error && <div className="auth-error">⚠️ {error}</div>}

          <form onSubmit={handleVerify}>
            <div className="form-group">
              <label>Enter 6-Digit Code</label>
              <input
                type="text"
                placeholder="123456"
                value={code}
                onChange={(e) => setCode(e.target.value)}
                maxLength={6}
                style={{ fontSize: '24px', letterSpacing: '8px', textAlign: 'center' }}
                required
              />
            </div>
            <button type="submit" className="auth-btn" disabled={loading}>
              {loading ? 'Verifying...' : 'Verify Email'}
            </button>
          </form>

          <p className="auth-switch" style={{ marginTop: '1rem' }}>
            Didn't receive code? Check spam folder or{' '}
            <span style={{ color: 'var(--primary)', cursor: 'pointer', fontWeight: '600' }}
              onClick={() => navigate('/register')}>
              register again
            </span>
          </p>
        </div>
      </div>
    </div>
  );
};

export default VerifyEmail;